__turbopack_context__.v({
  "discount": "plan-header-module__W52PQW__discount",
  "hide": "plan-header-module__W52PQW__hide",
  "pill": "plan-header-module__W52PQW__pill",
  "planHeader": "plan-header-module__W52PQW__planHeader",
  "price": "plan-header-module__W52PQW__price",
  "priceHeader": "plan-header-module__W52PQW__priceHeader",
  "show": "plan-header-module__W52PQW__show",
});
